import { PaymentCardBanner as PaymentCardBannerComponent } from '@mews/business-components';

import { CardTypeList } from '../CardTypeList';
import { inject } from './inject';

const BasePaymentCardBanner = (props: $TSFixMe) => (
    <PaymentCardBannerComponent {...props}>
        <CardTypeList />
    </PaymentCardBannerComponent>
);

// @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
export const PaymentCardBanner = inject(BasePaymentCardBanner);
